import { render, staticRenderFns } from "./productcenter.vue?vue&type=template&id=7602b2b8&scoped=true&"
import script from "./productcenter.vue?vue&type=script&lang=js&"
export * from "./productcenter.vue?vue&type=script&lang=js&"
import style0 from "./productcenter.vue?vue&type=style&index=0&id=7602b2b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7602b2b8",
  null
  
)

export default component.exports